// extracted by mini-css-extract-plugin
export default {"toggler":"BookingTimeWorkFormTogglerStyles_toggler__pfLHI","active":"BookingTimeWorkFormTogglerStyles_active__10r-L"};